import React, { ReactNode } from 'react'

import { Gift, Lightbulb, PlayArrow, SizeChart, Straighten } from '@Assets/SVG'
import { PageType } from '@Generated/graphql'

export interface SizeGuideItemProps {
  icon: ReactNode
  key: string
  pageID?: string
  pageType?: PageType
  title: string
  useDefault?: boolean
}

export const SizeGuideMap: Record<string, SizeGuideItemProps[]> = {
  boxers: [
    {
      key: 'measure',
      title: 'Measure',
      useDefault: true,
      icon: <Straighten />,
    },
    {
      key: 'chart',
      pageID: '2227',
      pageType: PageType.Landingpage,
      title: 'Size Chart',
      useDefault: false,
      icon: <SizeChart />,
    },
    {
      key: 'video',
      pageID: '2230',
      pageType: PageType.Landingpage,
      title: 'Video',
      useDefault: false,
      icon: <PlayArrow />,
    },
    {
      key: 'tips',
      pageID: '2250',
      pageType: PageType.Landingpage,
      title: 'Tips',
      useDefault: false,
      icon: <Lightbulb />,
    },
    {
      key: 'gifting',
      pageID: '2205',
      pageType: PageType.Landingpage,
      title: 'Gifting',
      useDefault: false,
      icon: <Gift />,
    },
  ],
  rings: [
    {
      key: 'measure',
      title: 'Measure',
      useDefault: true,
      icon: <Straighten />,
    },
    {
      key: 'chart',
      pageID: '2227',
      pageType: PageType.Landingpage,
      title: 'Size Chart',
      useDefault: false,
      icon: <SizeChart />,
    },
    {
      key: 'video',
      pageID: '2230',
      pageType: PageType.Landingpage,
      title: 'Video',
      useDefault: false,
      icon: <PlayArrow />,
    },
    {
      key: 'tips',
      pageID: '2250',
      pageType: PageType.Landingpage,
      title: 'Tips',
      useDefault: false,
      icon: <Lightbulb />,
    },
    {
      key: 'gifting',
      pageID: '2205',
      pageType: PageType.Landingpage,
      title: 'Gifting',
      useDefault: false,
      icon: <Gift />,
    },
  ],
  gloves: [
    {
      key: 'measure',
      title: 'Measure',
      useDefault: true,
      icon: <Straighten />,
    },
    {
      key: 'chart',
      pageID: '2227',
      pageType: PageType.Landingpage,
      title: 'Size Chart',
      useDefault: false,
      icon: <SizeChart />,
    },
    {
      key: 'video',
      pageID: '2230',
      pageType: PageType.Landingpage,
      title: 'Video',
      useDefault: false,
      icon: <PlayArrow />,
    },
    {
      key: 'tips',
      pageID: '2250',
      pageType: PageType.Landingpage,
      title: 'Tips',
      useDefault: false,
      icon: <Lightbulb />,
    },
    {
      key: 'gifting',
      pageID: '2205',
      pageType: PageType.Landingpage,
      title: 'Gifting',
      useDefault: false,
      icon: <Gift />,
    },
  ],
  bracelets: [
    {
      key: 'measure',
      pageID: '2252',
      title: 'Measure',
      useDefault: true,
      icon: <Straighten />,
    },
    {
      key: 'chart',
      pageID: '2253',
      pageType: PageType.Landingpage,
      title: 'Size Chart',
      useDefault: false,
      icon: <SizeChart />,
    },
    {
      key: 'video',
      pageID: '2254',
      pageType: PageType.Landingpage,
      title: 'Video',
      useDefault: false,
      icon: <PlayArrow />,
    },
    {
      key: 'tips',
      pageID: '2255',
      pageType: PageType.Landingpage,
      title: 'Tips',
      useDefault: false,
      icon: <Lightbulb />,
    },
    {
      key: 'gifting',
      pageID: '2256',
      pageType: PageType.Landingpage,
      title: 'Gifting',
      useDefault: false,
      icon: <Gift />,
    },
  ],
  necklaces: [
    {
      key: 'measure',
      title: 'Measure',
      useDefault: true,
      icon: <Straighten />,
    },
    {
      key: 'chart',
      pageID: '2227',
      pageType: PageType.Landingpage,
      title: 'Size Chart',
      useDefault: false,
      icon: <SizeChart />,
    },
    {
      key: 'video',
      pageID: '2230',
      pageType: PageType.Landingpage,
      title: 'Video',
      useDefault: false,
      icon: <PlayArrow />,
    },
    {
      key: 'tips',
      pageID: '2250',
      pageType: PageType.Landingpage,
      title: 'Tips',
      useDefault: false,
      icon: <Lightbulb />,
    },
    {
      key: 'gifting',
      pageID: '2205',
      pageType: PageType.Landingpage,
      title: 'Gifting',
      useDefault: false,
      icon: <Gift />,
    },
  ],
  hats: [
    {
      key: 'measure',
      title: 'Measure',
      useDefault: true,
      icon: <Straighten />,
    },
    {
      key: 'chart',
      pageID: '2227',
      pageType: PageType.Landingpage,
      title: 'Size Chart',
      useDefault: false,
      icon: <SizeChart />,
    },
    {
      key: 'video',
      pageID: '2230',
      pageType: PageType.Landingpage,
      title: 'Video',
      useDefault: false,
      icon: <PlayArrow />,
    },
    {
      key: 'tips',
      pageID: '2250',
      pageType: PageType.Landingpage,
      title: 'Tips',
      useDefault: false,
      icon: <Lightbulb />,
    },
    {
      key: 'gifting',
      pageID: '2205',
      pageType: PageType.Landingpage,
      title: 'Gifting',
      useDefault: false,
      icon: <Gift />,
    },
  ],
  belts: [
    {
      key: 'measure',
      title: 'Measure',
      useDefault: true,
      icon: <Straighten />,
    },
    {
      key: 'chart',
      pageID: '2227',
      pageType: PageType.Landingpage,
      title: 'Size Chart',
      useDefault: false,
      icon: <SizeChart />,
    },
    {
      key: 'video',
      pageID: '2230',
      pageType: PageType.Landingpage,
      title: 'Video',
      useDefault: false,
      icon: <PlayArrow />,
    },
    {
      key: 'tips',
      pageID: '2250',
      pageType: PageType.Landingpage,
      title: 'Tips',
      useDefault: false,
      icon: <Lightbulb />,
    },
    {
      key: 'gifting',
      pageID: '2205',
      pageType: PageType.Landingpage,
      title: 'Gifting',
      useDefault: false,
      icon: <Gift />,
    },
  ],
  watches: [
    {
      key: 'measure',
      title: 'Measure',
      useDefault: true,
      icon: <Straighten />,
    },
    {
      key: 'chart',
      pageID: '2227',
      pageType: PageType.Landingpage,
      title: 'Size Chart',
      useDefault: false,
      icon: <SizeChart />,
    },
    {
      key: 'video',
      pageID: '2230',
      pageType: PageType.Landingpage,
      title: 'Video',
      useDefault: false,
      icon: <PlayArrow />,
    },
    {
      key: 'tips',
      pageID: '2250',
      pageType: PageType.Landingpage,
      title: 'Tips',
      useDefault: false,
      icon: <Lightbulb />,
    },
    {
      key: 'gifting',
      pageID: '2205',
      pageType: PageType.Landingpage,
      title: 'Gifting',
      useDefault: false,
      icon: <Gift />,
    },
  ],
}
